// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Insights Page Styles */

.insights-form {
  width: 90%;
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 24px;
  /* margin-top: 20px; */
}
/* .insights .title {
  display: flex;
  align-items: center;
} */

.insights-premium {
  display: flex;
  align-items: center;
  margin-left: 5px;
  font-size: 14px;
  color: red;
}

.insights-premium i {
  color: #46127bc5;
  margin-right: 5px;
}

.insights h5 {
  margin-bottom: 0;
  margin-left: 5px;
}

.insights-form-title {
  font-size: 1.2rem;
  font-weight: 600;
  margin-bottom: 20px;
  color: #333;
}

.insights-form-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

.insights-form-group {
  display: flex;
  flex-direction: column;
}

.insights-form-group label {
  font-weight: 500;
  margin-bottom: 6px;
  color: #444;
}

.insights-form-group select,
.insights-form-group input[type="checkbox"] {
  padding: 8px 10px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.insights-checkbox-group {
  display: flex;
  align-items: center;
  margin-top: 10px;
}

.insights-checkbox-group input {
  margin-right: 8px;
}

.insights-file-button {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 30px;
  gap: 16px;
  flex-wrap: wrap;
}

.insights-file-button input[type="file"] {
  flex: 1 1;
}

.insights-file-button button {
  background-color: #457b9d;
  color: #fff;
  border: none;
  border-radius: 0;
  padding: 5px 10px;
  /* font-size: 18px; */
  cursor: pointer;
}

.insights-file-button button:hover {
  background-color: #2f6281;
}

/* Insight dropdown-insights */
.dropdown-insights {
  position: relative;
  display: inline-block;
  margin-left: 0.5rem;
  color: #333;
}

.dropdown-insights-btn {
  padding: 6px 12px;
  background-color: #f0f0f0;
  border: none;
  cursor: pointer;
}

.dropdown-insights-content {
  color: #333;
  display: none;
  position: absolute;
  background-color: white;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  min-width: 200px;
  z-index: 10;
  border-radius: 4px;
}

.dropdown-insights:hover .dropdown-insights-content {
  display: block;
}

.dropdown-insights-content button {
  padding: 8px 12px;
  width: 100%;
  text-align: left;
  border: none;
  background: none;
  cursor: pointer;
  color: #333;
}

.dropdown-insights-content button:hover {
  background-color: #ccc;
}

/* Insight markdown */

/* From Uiverse.io by AlimurtuzaCodes */ 
.button-download-insight {
  border: none;
  width: 10em;
  height: 3em;
  border-radius: 3em;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  background: #1C1A1C;
  cursor: pointer;
  transition: all 400ms ease-in-out;
}

.icon-download-insight {
  fill: #AAAAAA;
  transition: all 800ms ease;
}

.button-download-insight span {
  font-weight: 600;
  color: #AAAAAA;
  font-size: medium;
}

.button-download-insight:hover {
  background: linear-gradient(0deg,#A47CF3,#683FEA);
  box-shadow: inset 0px 1px 0px 0px rgba(255, 255, 255, 0.4),
  inset 0px -3px 0px 0px rgba(0, 0, 0, 0.2),
  0px 0px 0px 3px rgba(255, 255, 255, 0.2),
  0px 0px 180px 0px #9917FF;
  transform: translateY(-2px);
}

.button-download-insight:hover span {
  color: white;
}

.button-download-insight:hover .icon.download-insight {
  fill: white;
  transform: scale(1.2);
} 


.btn-download-insight {
  background-color: #457b9d;
  color: #fff;
  border: none;
  border-radius: 0;
  padding: 5px 10px;
  cursor: pointer;
}

.btn-download-insight:hover {
  background-color: #2f6281;
  color: #fff;
}

.kpi-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 16px;
}

.kpi-card {
  background-color: #f3f4f6; /* similar a gray-100 */
  padding: 16px;
  border-radius: 8px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
}

.kpi-label {
  font-size: 0.875rem;
  color: #6b7280; /* similar a gray-500 */
  margin-bottom: 4px;
}

.kpi-value {
  font-size: 1.25rem;
  font-weight: bold;
}

.chart-container {
  width: 70%;
  height: 300px;
  margin-bottom: 5%;
}

@media (max-width: 768px) {
  .insights-file-button {
    flex-direction: column;
    align-items: stretch;
  }

  .button-download-insight {
    width: 100%;
    max-width: 100%;
  }
}

`, "",{"version":3,"sources":["webpack://./src/pages/Insights/insights.css"],"names":[],"mappings":"AAAA,yBAAyB;;AAEzB;EACE,UAAU;EACV,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;AACA;;;GAGG;;AAEH;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;;EAEE,iBAAiB;EACjB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,0CAA0C;EAC1C,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA,qBAAqB;;AAErB,uCAAuC;AACvC;EACE,YAAY;EACZ,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,iDAAiD;EACjD;;;2BAGyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;;AAGA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,yBAAyB,EAAE,uBAAuB;EAClD,aAAa;EACb,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,cAAc,EAAE,uBAAuB;EACvC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;AACF","sourcesContent":["/* Insights Page Styles */\n\n.insights-form {\n  width: 90%;\n  background-color: #f9f9f9;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  padding: 24px;\n  /* margin-top: 20px; */\n}\n/* .insights .title {\n  display: flex;\n  align-items: center;\n} */\n\n.insights-premium {\n  display: flex;\n  align-items: center;\n  margin-left: 5px;\n  font-size: 14px;\n  color: red;\n}\n\n.insights-premium i {\n  color: #46127bc5;\n  margin-right: 5px;\n}\n\n.insights h5 {\n  margin-bottom: 0;\n  margin-left: 5px;\n}\n\n.insights-form-title {\n  font-size: 1.2rem;\n  font-weight: 600;\n  margin-bottom: 20px;\n  color: #333;\n}\n\n.insights-form-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 16px;\n}\n\n.insights-form-group {\n  display: flex;\n  flex-direction: column;\n}\n\n.insights-form-group label {\n  font-weight: 500;\n  margin-bottom: 6px;\n  color: #444;\n}\n\n.insights-form-group select,\n.insights-form-group input[type=\"checkbox\"] {\n  padding: 8px 10px;\n  font-size: 14px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n\n.insights-checkbox-group {\n  display: flex;\n  align-items: center;\n  margin-top: 10px;\n}\n\n.insights-checkbox-group input {\n  margin-right: 8px;\n}\n\n.insights-file-button {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 30px;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.insights-file-button input[type=\"file\"] {\n  flex: 1;\n}\n\n.insights-file-button button {\n  background-color: #457b9d;\n  color: #fff;\n  border: none;\n  border-radius: 0;\n  padding: 5px 10px;\n  /* font-size: 18px; */\n  cursor: pointer;\n}\n\n.insights-file-button button:hover {\n  background-color: #2f6281;\n}\n\n/* Insight dropdown-insights */\n.dropdown-insights {\n  position: relative;\n  display: inline-block;\n  margin-left: 0.5rem;\n  color: #333;\n}\n\n.dropdown-insights-btn {\n  padding: 6px 12px;\n  background-color: #f0f0f0;\n  border: none;\n  cursor: pointer;\n}\n\n.dropdown-insights-content {\n  color: #333;\n  display: none;\n  position: absolute;\n  background-color: white;\n  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);\n  min-width: 200px;\n  z-index: 10;\n  border-radius: 4px;\n}\n\n.dropdown-insights:hover .dropdown-insights-content {\n  display: block;\n}\n\n.dropdown-insights-content button {\n  padding: 8px 12px;\n  width: 100%;\n  text-align: left;\n  border: none;\n  background: none;\n  cursor: pointer;\n  color: #333;\n}\n\n.dropdown-insights-content button:hover {\n  background-color: #ccc;\n}\n\n/* Insight markdown */\n\n/* From Uiverse.io by AlimurtuzaCodes */ \n.button-download-insight {\n  border: none;\n  width: 10em;\n  height: 3em;\n  border-radius: 3em;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 12px;\n  background: #1C1A1C;\n  cursor: pointer;\n  transition: all 400ms ease-in-out;\n}\n\n.icon-download-insight {\n  fill: #AAAAAA;\n  transition: all 800ms ease;\n}\n\n.button-download-insight span {\n  font-weight: 600;\n  color: #AAAAAA;\n  font-size: medium;\n}\n\n.button-download-insight:hover {\n  background: linear-gradient(0deg,#A47CF3,#683FEA);\n  box-shadow: inset 0px 1px 0px 0px rgba(255, 255, 255, 0.4),\n  inset 0px -3px 0px 0px rgba(0, 0, 0, 0.2),\n  0px 0px 0px 3px rgba(255, 255, 255, 0.2),\n  0px 0px 180px 0px #9917FF;\n  transform: translateY(-2px);\n}\n\n.button-download-insight:hover span {\n  color: white;\n}\n\n.button-download-insight:hover .icon.download-insight {\n  fill: white;\n  transform: scale(1.2);\n} \n\n\n.btn-download-insight {\n  background-color: #457b9d;\n  color: #fff;\n  border: none;\n  border-radius: 0;\n  padding: 5px 10px;\n  cursor: pointer;\n}\n\n.btn-download-insight:hover {\n  background-color: #2f6281;\n  color: #fff;\n}\n\n.kpi-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 16px;\n}\n\n.kpi-card {\n  background-color: #f3f4f6; /* similar a gray-100 */\n  padding: 16px;\n  border-radius: 8px;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);\n}\n\n.kpi-label {\n  font-size: 0.875rem;\n  color: #6b7280; /* similar a gray-500 */\n  margin-bottom: 4px;\n}\n\n.kpi-value {\n  font-size: 1.25rem;\n  font-weight: bold;\n}\n\n.chart-container {\n  width: 70%;\n  height: 300px;\n  margin-bottom: 5%;\n}\n\n@media (max-width: 768px) {\n  .insights-file-button {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .button-download-insight {\n    width: 100%;\n    max-width: 100%;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
